import { useMutation } from '@tanstack/react-query';
import {
  CreateHiloEinvoiceAccountDto,
  EInvoiceAccountsService,
} from 'services/openapi';

export const useCreateEInvoiceAccountMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, CreateHiloEinvoiceAccountDto>({
      mutationFn: (variables: CreateHiloEinvoiceAccountDto) => {
        return EInvoiceAccountsService.einvoiceAccountControllerCreateHiloAccount(
          variables,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
